<template>
  <div
    class="bg-burgundy relative w-75 lg:w-[780px] p-2.5 lg:text-center transition-[margin] col-start-1 lg:col-start-2 col-end-3 lg-col-end-4 row-start-1 row-end-3"
  >
    <div
      v-if="$content.options.value.contact?.newsletter"
      class="px-5 lg:px-32 py-7.5 lg:py-17.5 border border-pink transition-[padding] h-full"
    >
      <p class="font-subtitle mb-2.5 text-4xl lg:text-6xl uppercase">
        {{ $content.options.value.contact.newsletter.title }}
      </p>
      <p class="max-w-115 mx-auto">
        {{ $content.options.value.contact.newsletter.description }}
      </p>
      <form action="" class="relative max-w-97.5 mx-auto" @submit.prevent="submit">
        <label for="newsletter" class="hidden">{{ $t('your_email') }}</label>
        <input
          type="text"
          id="newsletter"
          v-model="form.fields.newsletter.value"
          name="newsletter"
          :placeholder="$t('your_email')"
          class="w-full border-b border-pink py-2.5 focus:outline-none"
        />
        <button
          type="submit"
          :class="[
            'opacity-0 absolute bottom-2.5 right-0 text-pink z-10 transition-opacity',
            { 'opacity-100': form.fields.newsletter.valid },
          ]"
        >
          <IconSprite id="send" />
        </button>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import IconSprite from '@/components/helpers/IconSprite.vue'

export default {
  name: 'NewsletterForm',
  components: { IconSprite },
  data() {
    return {
      form: {
        fields: {
          newsletter: {
            value: '',
            valid: false,
          },
        },
      },
    }
  },
  methods: {
    async submit() {
      //todo
    },
  },
  watch: {
    'form.fields.newsletter.value'() {
      this.form.fields.newsletter.valid = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/.test(
        this.form.fields.newsletter.value,
      )
    },
  },
}
</script>
